import React from "react";
import { IWorkshopSessions } from "./WorkshopSessions.interfaces";
import SingleSession from "./modules/SingleSession/SingleSession";
import MultipleSessions from "./modules/MultipleSessions/MultipleSessions";

const WorkshopSessions = ({
    sessions,
    sessionsCount,
    hide,
}: IWorkshopSessions) => {
    if (hide) return null;

    const WorkshopSessionComponent =
        sessionsCount === 1 ? SingleSession : MultipleSessions;

    return <WorkshopSessionComponent sessions={sessions} />;
};

export default WorkshopSessions;
